import { render, staticRenderFns } from "./SupportBar.vue?vue&type=template&id=fd83222a"
import script from "./SupportBar.vue?vue&type=script&lang=ts"
export * from "./SupportBar.vue?vue&type=script&lang=ts"
import style0 from "./SupportBar.vue?vue&type=style&index=0&id=fd83222a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports